
( function ( $ ) {

	var renderResourceListing = function() {
    var cur_category = $('#category-filter').val();
    var cur_last_modified_year = $('#last-modified-year-filter').val();
    var cur_last_modified_month = $('#last-modified-month-filter').val();
    var cur_published_year = $('#published-year-filter').val();
    var cur_published_month = $('#published-month-filter').val();		  
	  $("#resource-listing-table tbody tr").each(function(){
	    var $this = $(this);

	    $this.removeClass('hide');
	    if (!$this.hasClass(cur_category) || 
	    	!$this.hasClass(cur_last_modified_year) || 
	    	!$this.hasClass(cur_last_modified_month) || 
	    	!$this.hasClass(cur_published_year) || 
	    	!$this.hasClass(cur_published_month) ) {
	    	$this.addClass('hide');
	    }
	  });
	};

	var registerPostMessageListener = function() {
		window.addEventListener('message', function (e) {
		  var origin_ok = false;

		  if (/force\.com$/.test(e.origin)) {
			origin_ok = true;
		  } else if (/liberal\.ca$/.test(e.origin)) {
			origin_ok = true;
		  } else if (/wordpress\.test$/.test(e.origin)) {
			origin_ok = true;
		  } else if (/liberal\.test$/.test(e.origin)) {
			origin_ok = true;
		  }
		  if (!origin_ok) {
			return;
		  }
		  var payload = e.data;

		  switch(payload.method) {
			case 'set-iframe-height':
				var height = payload.data;
				var iframe_href = payload.iframe_href;
				var $iframe = jQuery("iframe[src*='" + iframe_href + "']");
				console.log("iframe[src*='" + iframe_href + "']");	  
				$iframe.height(height);  
			break;
		  }

		}, false);		
	}

	function setPageTopPadding() {
		var header_bar_outer_height = $('nav.header-bar').outerHeight();
		$('body').css('padding-top', header_bar_outer_height + 'px');
	}

	$(document).ready(function() {
		$('#category-filter, #last-modified-year-filter, #last-modified-month-filter, #published-month-filter, #published-year-filter').on('change', function(e){
			renderResourceListing();
		});

		$('#filter-reset').on('click', function(){
	    $('#category-filter').val('cat--all');
	    $('#last-modified-year-filter').val('last-modified-year--all');
	    $('#last-modified-month-filter').val('last-modified-month--all');
	    $('#published-year-filter').val('published-year--all');
	    $('#published-month-filter').val('published-month--all');

	    renderResourceListing();					
		});

		$('#field-sort').on('change', function(e){
			var sort_order = $('#sort-order').val();
			var field_index = $('#field-sort').val();
			sortTable(field_index, sort_order);
		});

		$('#sort-order').on('change', function(e){
			var sort_order = $('#sort-order').val();
			var field_index = $('#field-sort').val();
			sortTable(field_index, sort_order);
		});

		registerPostMessageListener();

		setPageTopPadding();
		$(window).on('resize', function(){
			setPageTopPadding();
		});
  });
  
	// https://www.w3schools.com/howto/howto_js_sort_table.asp
	function sortTable(table_column_index, dir) {
	  var table, rows, switching, i, x, y, shouldSwitch,  switchcount = 0;
	  table = document.getElementById("resource-listing-table");
	  switching = true;
	  // Set the sorting direction to ascending:
	  console.log('sorting');
	  /* Make a loop that will continue until
	  no switching has been done: */
	  while (switching) {
	    // Start by saying: no switching is done:
	    switching = false;
	    rows = table.rows;
	    /* Loop through all table rows (except the
	    first, which contains table headers): */
	    for (i = 1; i < (rows.length - 1); i++) {
	      // Start by saying there should be no switching:
	      shouldSwitch = false;
	      /* Get the two elements you want to compare,
	      one from current row and one from the next: */
	      x = rows[i].getElementsByTagName("TD")[table_column_index];
	      y = rows[i + 1].getElementsByTagName("TD")[table_column_index];
	      /* Check if the two rows should switch place,
	      based on the direction, asc or desc: */
	      if (dir == "asc") {
	        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
	          // If so, mark as a switch and break the loop:
	          shouldSwitch = true;
	          break;
	        }
	      } else if (dir == "desc") {
	        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
	          // If so, mark as a switch and break the loop:
	          shouldSwitch = true;
	          break;
	        }
	      }
	    }
	    if (shouldSwitch) {
	      /* If a switch has been marked, make the switch
	      and mark that a switch has been done: */
	      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
	      switching = true;
	      // Each time a switch is done, increase this count by 1:
	      switchcount ++; 
	    } else {
	      /* If no switching has been done AND the direction is "asc",
	      set the direction to "desc" and run the while loop again. */
	      if (switchcount == 0 && dir == "asc") {
	        dir = "desc";
	        switching = true;
	      }
	    }
	  }
	}

} ( jQuery ) )

